import React, { lazy, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
// const { ToastContainer } = lazy(() => import('react-toastify'));
import { ToastContainer } from 'react-toastify';
import Loader from './common/Loader';
import MetaTags from './common/MetaTags';
import Extole from './components/integration/Extole';
import { notification } from './store/actions';
import { extractCSStoHTML, isPrerenderBrowser } from './utils/helper';
const NewFooter = lazy(() => import('./common/footer/NewFooter'));

function Main(props) {
  const history = useHistory();
  const match = useRouteMatch();
  useEffect(() => {
    if (window.message) {
      props.onNotification(window.message, 'success');
      window.message = '';
    }

    if (window.message) {
      props.onNotification(window.error, 'error');
      window.error = '';
    }

    if (localStorage.getItem('redirectTo')) {
      const redirectTo = localStorage.getItem('redirectTo');
      localStorage.removeItem('redirectTo');
      history.push(redirectTo);
    }

    if (isPrerenderBrowser()) {
      setInterval(() => {
        extractCSStoHTML();
      }, 500);
    }
  }, []);

  const setMargin = () => {
    if (!match.path.startsWith('/admin')) {
      return 'p-0 m-0';
    }
    return '';
  };

  return (
    <>
      <MetaTags />
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover
      />
      <Loader />
      <div>
        <div className="main">
          <div className={`container-fluid ${setMargin()}`}>
            <div className={`row ${setMargin()}`}>
              <div className={`col-md-12 ${setMargin()}`}>{props.children}</div>
            </div>
          </div>
          <Extole />
          <NewFooter />
          {/* <Footer /> */}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user,
    localCart: state.LocalCart.localCart
  };
};

const mapDispatchToProps = dispatch => ({
  onNotification: (message, type) => {
    dispatch(notification({ message, type }));
  }
});

const connecter = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default connecter(Main);
